import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/courses', payload)
    return response || null
  },
  
  async update(payload) {
    let response = await api.put('/admin/courses', payload)
    return response
  },

  async delete(payload) {
    const response = await api.delete('/admin/courses', {
      data: payload,
    })
    return response
  },

  async getList(params) {
    let response = await api.get('/admin/courses', {
      params,
    })
    return response.data.data
  },

  async get(params) {
    let response = await api.get('/admin/courses/detail', {
      params,
    })
    return response.data.data.document || null
  },

}
